import React from "react";
import dynamic from "next/dynamic";
import Grid from "ui/Grid/Grid";
import LazyImage from "ui/LazyImage/LazyImage";
import { useDevice } from "helpers/hooks";
import styles from "./Apps.module.scss";

const AppGallery = dynamic(() => import("assets/icons/apps/app-gallery.svg"));
const AppStore = dynamic(() => import("assets/icons/apps/app-store.svg"));
const GooglePlay = dynamic(() => import("assets/icons/apps/google-play.svg"));

const Apps: React.FC = () => {
  const device = useDevice();

  const renderApps = () => {
    return (
      <Grid item sm={12} lg={6}>
        <p className={styles.footerAppsTitle} />
        <div className={styles.footerAppsOnNotTablet}>
          <div className={styles.footerAppsGrid}>
            {(device.isDesktop || device.isIOS) && (
              <a
                className={styles.footerAppsItem}
                aria-label="App Store"
                href="https://zdravcity.ru/redirect.php?site=http://itunes.apple.com/ru/app/zdravsiti/id1119115786?mt=8"
              >
                <AppStore />
              </a>
            )}
            {(device.isDesktop || device.isAndroid) && (
              <>
                <a
                  className={styles.footerAppsItem}
                  aria-label="Google Play"
                  href="https://zdravcity.ru/redirect.php?site=http://play.google.com/store/apps/details?id=ru.zdravcity.app&hl=ru"
                >
                  <GooglePlay />
                </a>
                <a
                  className={styles.footerAppsItem}
                  aria-label="App Gallery"
                  href="https://appgallery.huawei.com/#/app/C102626077"
                >
                  <AppGallery />
                </a>
              </>
            )}
          </div>
        </div>
      </Grid>
    );
  };

  return (
    <>
      {renderApps()}
      <div className={styles.footerAppsOnNotMobile}>
        <Grid item sm={12} lg={6}>
          <div className={styles.footerAppsQrContainer}>
            <LazyImage
              className={styles.footerAppsDeviceQr}
              src="/img/footer/qr-app.png"
              alt="APP QR"
            />

            <div className={styles.footerAppsQrInfo}>
              <div className={styles.footerAppsInfoIcon}>
                Наведите камеру на <span>QR-код</span>, чтобы скачать
              </div>
              <LazyImage
                className={styles.footerAppsNotice}
                src="/img/footer/qr-arrow.svg"
                alt="QR arrow"
              />
            </div>
          </div>
        </Grid>
      </div>
    </>
  );
};
export default Apps;
